module.exports = __webpack_public_path__ + "img/createresume.17253931.svg";